import { makeStyles } from "@mui/styles";
const useLoginSignupStyles = makeStyles(() => {
  return {
    loginTrialContainer: {
      background: "none",
      width: "-webkit-fill-available",
      margin: "-44px 0px 0px 0px",
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      flexDirection: "row",
      "&.mobile": {
        display: "none",
      },
    },

    loginOuterContainer: {
      display: "flex",
      flexDirection: "column",
    },

    loginInnerContainer: {
      display: "flex",
    },

    form: {
      display: "flex",
      flexDirection: "row",

      "&.mobile": {
        flexDirection: "column  !important",
      },
    },
    tourGuideImageStyle: {
      paddingTop: "25px ",
    },
    emailBox: {
      marginRight: "16px",
      marginBottom: "10px",
    },

    buttonsHolder: {
      display: "flex",
      height: "40px",

      "&.mobile": {
        marginBottom: "10px  !important",
        marginTop: "10px  !important",
        justifyContent: "center",
      },
    },

    forgotPasswordOuterContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "20px",
    },

    forgotPasswordInnerContainer: {
      display: "flex",
      alignItems: "center",
      marginLeft: "430px",
      cursor: "pointer",

      " &.mobile": {
        marginLeft: "80px  !important",
      },
    },

    forgotPassword: {
      fontSize: "16px",
      fontWeight: "400",
      fontFamily: "Lato",
    },

    lineTrialCOntainer: {
      display: "flex",
    },

    guideTrialContainer: {
      marginLeft: "25px",
      marginTop: "-10px",
      display: "flex",
      flexDirection: "row",
      " &.mobile": {
        marginLeft: "0px",
        marginTop: "0px",
      },
    },

    signupExitContainer: {
      display: "flex",
      height: "40px",
      marginTop: "40px",
      justifyContent: "space-around",
    },

    signupConfirmMsgContainer: {
      margin: "20px 0px 20px 0px",
    },

    signupConfirmMsg: {
      color: "white",
    },

    resendVerifyBtnsContainer: {
      margin: "40px 0px 20px",
      display: "flex",
      justifyContent: "center",
    },
    verifyBtnsContainer: {
      margin: "20px 0px 20px",
      display: "flex",
      justifyContent: "center",
      "&.verifyBtn": {
        width: "130px",
      },
    },
    createAccountContainer: {
      margin: "35px 0px 15px 10px",
    },
    exitSignupContainer: {
      display: "flex",
      justifyContent: "center",
      padding: "30px",
    },
    createAccount: {
      color: "white",
    },

    ternsServiceContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: "8px",
    },

    rWoodDocsAPi: {
      fontSize: "16px",
      fontWeight: "400",
      fontFamily: "Lato",
      color: "white",
      cursor: "pointer",
    },
    toolTip: {
      marginLeft: "8px",
      marginTop: "3px",
    },
    wrongInput: {
      marginTop: "4px",
    },
    cancelSignupBtnsHolder: {
      padding: "0px 20px 0px 0px",
      display: "flex",
      justifyContent: "center",
    },
    exitSignUpBtnsHolder: {
      padding: "0px 20px 0px 20px",
      display: "flex",
      justifyContent: "space-evenly",
    },
    dialogTitle: {
      background: "#002B49",
    },
    signupImage: {
      display: "flex",
      justifyContent: "space-around",
    },
    signupClose: {
      position: "absolute",
      top: 10,
      right: 10,
      color: "white",
      cursor: "pointer",
    },
    dialogContent: {
      background: "#002B49",
    },

    email: {
      width: "272px !important",
      background: "#FFFFFF ",
    },

    checkBox: {
      color: "white !important",
      "&.Mui-checked": { color: "white" },
    },

    emailPlaceHolder: {
      width: "100%",
    },

    loginBtn: {
      margin: "0 20px !important",
      width: "150px",

      "&.mobile": {
        margin: "0px 10px 0px 0px !important",
        width: "105px",
      },
    },

    signUpBtn: {
      width: "130px",

      "&.mobile": {
        margin: "0px 10px 0px 0px !important",
        width: "105px",
      },
    },

    signUpTour: {
      width: "150px",
    },

    exitGuide: {
      minWidth: "165px",
    },

    tourGuideImage: {
      cursor: "pointer",
      height: "30px",
      "&.bounceEffect": {
        animation: "bounce 0.4s infinite alternate",
      },
    },
    code: {
      width: "100% ",
    },

    resendCode: {
      width: "120px !important",
      margin: "5px !important",
      fontSize: "15px !important",

      "&.mobile": {
        fontSize: "10px !important",
      },
    },

    verifyCode: {
      width: "120px !important",
      margin: "5px !important",
      fontSize: "15px !important",

      "&.mobile": {
        fontSize: "10px !important",
      },
    },
    userName: {
      backgroundColor: "white",
      borderRadius: "10px",
      width: "100% !important",
    },
    cancelBtn: {
      width: "100px !important",
    },
    signUpBtnInfo: {
      width: "100px !important",
    },

    signupDialog: {
      maxWidth: "500px",
      display: "flex-start",

      "&.mobile ": {
        maxWidth: null,
      },
    },
    alertPopupMobile: {
      padding: "2px !important",
      marginRight: "10% !important",
      marginTop: "100% !important",
      width: "80% !important",

      "&.mobile": {
        position: "fixed !important",
      },
    },
    alertPopupMobileconfirm: {
      left: "50% !important",
      transform: "translateX(-50%)",
      top: "auto !important",
      marginTop: "-5px !important",
      "&.mobile": {
        position: "fixed !important",
        marginRight: 0,
        marginLeft: 0,
      },
      "&.default": {
        position: "fixed !important",
        marginRight: 0,
        marginLeft: 0,
      },
    },
    password: {
      backgroundColor: "white",
      borderRadius: "10px",
      width: "100% !important",
    },
    confirmPassword: {
      backgroundColor: "white",
      borderRadius: "10px",
      width: "100% !important",
    },
    notVerifiedUser: {
      color: "#fff",
      cursor: "pointer",
    },
    alertPopupMobilesignUpInfo: {
      padding: "2px !important",
      marginTop: "30% !important",
      marginRight: "10% !important",
      width: "80% !important",
      "&.mobile ": {
        position: "fixed !important",
      },
    },
    TabsStyle: {
      "& .Mui-selected": {
        color: "#757575 !important",
      },
      padding: "20px 85px",
      minHeight: "32px",
    },
    TabStyle: {
      minHeight: "40px",
      maxHeight: "40px",
      minWidth: "95px",
      fontWeight: 600,
      borderBottom: "none",
      fontFamily: "Lato",
      fontSize: "14px",
      padding: 0,

      "&.defaultTabStyle": {
        background: "#EEEEEE",
        borderRadius: "6px !important",
        color: "#757575",
      },
      "&.selectedTabStyle": {
        background: "linear-gradient(90deg, #044F82 0%, #2C96DE 100%)",
        borderRadius: "6px 0px 0px 6px",
        color: "#ffffff",
      },
      "&.lastSelectedTabStyle": {
        borderRadius: "0px 6px 6px 0px !important ",
      },
    },
    viewPricingBtn: {
      display: "flex",
      justifyContent: "center",
      cursor: "pointer",
      color: "#FF6C37",
      textDecoration: "underline",
    },
    chatLiveBtn: {
      marginTop: "20px !important",
      marginLeft: "36% !important",
    },
    tryFreeTitle: {
      textTransform: "uppercase",
      color: "#2E9AE6",
      fontSize: "20px !important",
    },
    tryFreeSubTitle: {
      color: "#2E9AE6",
      marginTop: "-8px !important",
      fontSize: "14px !important",
    },
    tryFreeContainer: {
      border: "1px solid #2E9AE6",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
    },
    optionContainer: {
      display: "flex",
    },
    optionBox: {
      color: "#fff",
    },
    optionText: {
      color: "#fff",
    },
    optionTitle: {
      textTransform: "uppercase",
      color: "#FB8C65",
      fontSize: "16px !important",
    },
    monthText: {
      fontSize: "14px !important",
    },
  };
});

export default useLoginSignupStyles;
